module.exports = __webpack_public_path__ + "static/media/view2.3fface79.jpg";